import { useSetAtom } from 'jotai';
import { copyEventsEdtModalAtom } from './atom';

export const useOpenCopyEventsFromEDTModal = () =>
  useSetAtom(copyEventsEdtModalAtom);
